/**
 * Phát lần lượt các bước walkthrough. Hết một file thì đứng tại bước đó.
 * Close guide chỉ tạm dừng. Done ở bước cuối thì đóng hẳn.
 */

export function createWalkthroughController({
  steps,
  onChange,
  createAudio = (url) => new Audio(url),
}) {
  const list = Array.isArray(steps) ? steps : [];
  let index = 0;
  let audio = null;
  let playing = false;
  let closed = false;

  function emit() {
    if (typeof onChange !== 'function') return;
    onChange({
      index,
      step: closed ? null : (list[index] || null),
      playing,
      isLast: list.length > 0 && index >= list.length - 1,
      closed,
    });
  }

  function load(nextIndex) {
    if (audio) {
      audio.onended = null;
      audio.onerror = null;
      audio.pause();
    }
    index = nextIndex;
    audio = createAudio(list[index].audioUrl);
    audio.onended = () => {
      playing = false;
      emit();
    };
    audio.onerror = () => {
      playing = false;
      emit();
    };
  }

  function play() {
    if (!audio || closed) return;
    playing = true;
    emit();
    let played;
    try {
      played = audio.play();
    } catch (err) {
      playing = false;
      emit();
      return;
    }
    if (played && typeof played.catch === 'function') {
      played.catch(() => {
        playing = false;
        emit();
      });
    }
  }

  function closeGuide() {
    if (audio) audio.pause();
    playing = false;
    emit();
  }

  if (list.length) load(0);

  return {
    start: play,
    pause() {
      if (audio) audio.pause();
      playing = false;
      emit();
    },
    repeat() {
      if (!audio || closed) return;
      audio.currentTime = 0;
      play();
    },
    next() {
      if (closed || !list.length) return;
      if (index + 1 < list.length) {
        load(index + 1);
        play();
      } else {
        if (audio) audio.pause();
        playing = false;
        closed = true;
        emit();
      }
    },
    closeGuide,
    stop() {
      if (audio) {
        audio.onended = null;
        audio.onerror = null;
        audio.pause();
      }
      playing = false;
      closed = true;
    },
  };
}
